import React, { useEffect } from 'react';
import { QUESTION_TYPE } from '../../../../utils/Constants';
import { IconButton, Slide, Slider, Snackbar } from '@mui/material';
import { Button } from '@mui/material';
import { Stack } from '@mui/material';
import { Chip } from '@mui/material';
import {
  AddOutlined,
  ArrowRight,
  ControlPoint,
  DeleteOutline,
  EditOutlined,
} from '@mui/icons-material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import '../../../../resources/styling/App.scss';
import { Box } from '@mui/material';
import { Modal } from '@mui/material';
import questionService from '../../../../services/api/insights/questionService';
import AddEditQuestion from './AddEditQuestion';
import Alert from '@mui/material/Alert';
import { AppButton } from '../../../../resources/styling';
import { colors } from '../../../../resources/theme/colors';
import { OutlineButton } from '../../../../resources/styling/appStyle';
import { ca } from 'date-fns/locale';

const { mandy, pictonBlue } = colors;

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  p: 3,
};

export default function Question({
  question,
  id,
  updateAfterDelete,
  updateAfterEdit,
  canNotEdit,
  selectedQuestions,
  setSelectedQuestions,
}) {
  const [showAnswers, setShowAnswers] = React.useState(0);
  const [showDeleteWarning, setShowDeleteWarning] = React.useState(false);
  const [showSnackbar, setShowSnackbar] = React.useState(false);
  const [showEdit, setShowEdit] = React.useState(false);
  const [selectedQuestion, setSelectedQuestion] = React.useState(null);

  const getQuestionTypeName = (questionType) => {
    switch (questionType) {
      case QUESTION_TYPE.LIKERT:
        return 'Likert';
      case QUESTION_TYPE.COMMENTS:
        return 'Comments';
      case QUESTION_TYPE.MULTIPLE_CHOICE:
        return 'Multi Choice';
      case QUESTION_TYPE.MULTIPLE_SELECT:
        return 'Multi Select';
      case QUESTION_TYPE.NUMBER_SLIDER:
        return 'Number Slider';
      case QUESTION_TYPE.YES_NO:
        return 'Yes No';
      case QUESTION_TYPE.YES_NO_MAYBE:
        return 'Yes No Maybe';
      case QUESTION_TYPE.PERCENTAGE:
        return 'Percentage';
      case QUESTION_TYPE.RANKING:
        return 'Ranking';
    }
  };

  const handleDelete = () => {
    setShowDeleteWarning(false);
    questionService
      .delete(question.id)
      .then((res) => {
        setShowSnackbar(true);
        updateAfterDelete(question.id);
      })
      .catch((err) => console.error(err));
  };

  const renderDeleteWarning = () => {
    return (
      <Modal
        open={showDeleteWarning}
        onClose={() => setShowDeleteWarning(false)}
        title='Delete Question'
      >
        <Box sx={{ ...style }}>
          <h2>Delete Question</h2>
          <p>Are you sure you want to delete this question?</p>
          <Stack direction='row' justifyContent='flex-end' gap={1}>
            <OutlineButton
              color='error'
              onClick={() => setShowDeleteWarning(false)}
            >
              Cancel
            </OutlineButton>
            <AppButton color={mandy} onClick={handleDelete}>
              Delete
            </AppButton>
          </Stack>
        </Box>
      </Modal>
    );
  };

  const renderActions = () => (
    <div>
      {canNotEdit ? (
        <Stack direction='row' spacing={1}>
          {!selectedQuestions.some((x) => x.id == question.id) && (
            <IconButton
              onClick={() =>
                setSelectedQuestions([...selectedQuestions, { ...question }])
              }
            >
              <ControlPoint />
            </IconButton>
          )}
        </Stack>
      ) : (
        <Stack direction='row' spacing={1}>
          <IconButton onClick={() => setShowDeleteWarning(true)}>
            <svg
              width='20'
              height='20'
              viewBox='0 0 20 20'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M5.8335 17.5C5.37516 17.5 4.98294 17.3369 4.65683 17.0108C4.33072 16.6847 4.16738 16.2922 4.16683 15.8333V5H3.3335V3.33333H7.50016V2.5H12.5002V3.33333H16.6668V5H15.8335V15.8333C15.8335 16.2917 15.6704 16.6842 15.3443 17.0108C15.0182 17.3375 14.6257 17.5006 14.1668 17.5H5.8335ZM14.1668 5H5.8335V15.8333H14.1668V5ZM7.50016 14.1667H9.16683V6.66667H7.50016V14.1667ZM10.8335 14.1667H12.5002V6.66667H10.8335V14.1667Z'
                fill='#626262'
              />
            </svg>
          </IconButton>
          <IconButton
            disableRipple
            onClick={() => {
              setShowEdit(true);
              setSelectedQuestion(question);
            }}
          >
            <svg
              width='20'
              height='20'
              viewBox='0 0 20 20'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM2.5 17.5V13.9583L13.5 2.97917C13.6667 2.82639 13.8508 2.70833 14.0525 2.625C14.2542 2.54167 14.4658 2.5 14.6875 2.5C14.9092 2.5 15.1244 2.54167 15.3333 2.625C15.5422 2.70833 15.7228 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.3092 4.5 17.3858 4.70833C17.4625 4.91667 17.5006 5.125 17.5 5.33333C17.5 5.55556 17.4619 5.7675 17.3858 5.96917C17.3097 6.17083 17.1881 6.35472 17.0208 6.52083L6.04167 17.5H2.5ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z'
                fill='#626262'
              />
            </svg>
          </IconButton>
        </Stack>
      )}
    </div>
  );

  const renderSnackbar = () => (
    <Snackbar
      open={showSnackbar}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      slots={{ transition: <Slide direction='down' /> }}
      TransitionComponent={Slide}
      autoHideDuration={5000}
      onClose={() => setShowSnackbar(false)}
    >
      <Alert
        onClose={() => setShowSnackbar(false)}
        severity='success'
        variant='filled'
      >
        Question deleted successfully
      </Alert>
    </Snackbar>
  );

  const renderEditModal = () =>
    showEdit && (
      <AddEditQuestion
        doneEdit={setShowEdit}
        question={selectedQuestion}
        updateAfterEdit={updateAfterEdit}
      />
    );

  return (
    <li className='questions'>
      {renderDeleteWarning()}
      {renderSnackbar()}
      {renderEditModal()}
      <Stack direction='row' justifyContent='space-between'>
        <div>
          <h4>
            {question.staffText !== '' &&
              (question.audiences === 1 ||
                question.audiences === 3 ||
                question.audiences === 5 ||
                question.audiences === 7) && (
                <>
                  <strong>Staff: </strong>
                  {question.staffText}
                </>
              )}
          </h4>
          <h4>
            {question.parentText !== '' &&
            (question.audiences === 2 ||
              question.audiences === 3 ||
              question.audiences === 6 ||
              question.audiences === 7) ? (
              <>
                <strong>Parent: </strong>
                {question.parentText}
              </>
            ) : null}
          </h4>
          <h4>
            {question.pupilText !== '' &&
            (question.audiences === 4 ||
              question.audiences === 5 ||
              question.audiences === 6 ||
              question.audiences === 7) ? (
              <>
                <strong>Pupil: </strong>
                {question.pupilText}
              </>
            ) : null}
          </h4>
        </div>
        {renderActions()}
      </Stack>
      {(question.questionType === 2 ||
        (question.questionType > 3 && question.questionType < 9)) && (
        <div className='show-hide'>
          <Button
            disableRipple
            onClick={(e) =>
              setShowAnswers(showAnswers === question.id ? 0 : question.id)
            }
            startIcon={
              showAnswers === question.id ? (
                <ArrowDropDownIcon />
              ) : (
                <ArrowRight />
              )
            }
          >
            {showAnswers === question.id ? 'Hide' : 'Show'} Answers
          </Button>

          {showAnswers === question.id ? (
            <ul className='answers'>
              {question.multiOptionResponseAttributes.map((option) => (
                <li>
                  {question.audiences === 1 ||
                  question.audiences === 3 ||
                  question.audiences === 5 ||
                  question.audiences === 7
                    ? option.staffText
                    : question.audiences === 2 ||
                      question.audiences === 3 ||
                      question.audiences === 6 ||
                      question.audiences === 7
                    ? option.parentText
                    : question.audiences === 4 ||
                      question.audiences === 5 ||
                      question.audiences === 6 ||
                      question.audiences === 7
                    ? option.pupilText
                    : ''}
                </li>
              ))}
            </ul>
          ) : null}
        </div>
      )}
      <Chip label={getQuestionTypeName(question.questionType)} size='small' />
    </li>
  );
}
